// @ts-expect-error type not available yet
import ZorseGrrTaggingPanel from 'zorse-grr-tagging/containers/ZorseGrrTaggingPanel';
import { EscalationPanel } from 'zorse-crm-components-lib';
import { Fragment } from 'react';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ZorsePanels = ({
  threadId,
  isGrrPanelOpen,
  isEscalationPanelOpen,
  canResolveGrr,
  setIsGrrPanelOpen,
  setIsEscalationPanelOpen
}) => {
  const renderZorseGrrTaggingPanel = () => {
    return isGrrPanelOpen ? /*#__PURE__*/_jsx(ZorseGrrTaggingPanel, {
      isResolutionDisabled: !canResolveGrr,
      conversationId: parseInt(threadId, 10) || 0,
      onClose: () => setIsGrrPanelOpen(false),
      onResolved: () => setIsGrrPanelOpen(false)
    }) : null;
  };
  const renderZorseEscalationsPanel = () => {
    return isEscalationPanelOpen ? /*#__PURE__*/_jsx(EscalationPanel, {
      alertStore: FloatingAlertStore,
      applicationName: "conversations",
      conversationId: parseInt(threadId, 10) || 0,
      onClose: () => setIsEscalationPanelOpen(false),
      onError: () => {},
      onSubmit: () => setIsEscalationPanelOpen(false)
    }) : null;
  };
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [renderZorseGrrTaggingPanel(), renderZorseEscalationsPanel()]
  });
};
ZorsePanels.displayName = 'ZorsePanels';
export default ZorsePanels;